/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software; you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with this program;
 * if not, write to the Free Software Foundation, Inc., 51 Franklin Street, Fifth Floor,
 * Boston, MA  02110-1301, USA
 */

export type EmployeeNameInput = {
  firstName: string;
  middleName?: string | null;
  lastName: string;
  nickname?: string | null;
  nickName?: string | null;
};

export type EmployeeNameFormatOptions = {
  includeMiddle?: boolean;
  preferNickname?: boolean;
};

export function resolveEmployeeNickname(employee: EmployeeNameInput): string {
  return (employee.nickname ?? employee.nickName ?? '').trim();
}

export function formatEmployeeNameParts(
  employee: EmployeeNameInput,
  options?: EmployeeNameFormatOptions,
): string {
  const nickname = resolveEmployeeNickname(employee);
  if (options?.preferNickname && nickname) {
    return nickname;
  }

  const includeMiddle =
    typeof options?.includeMiddle === 'boolean' ? options.includeMiddle : true;

  const parts = [employee.firstName];
  if (
    includeMiddle &&
    employee.middleName &&
    String(employee.middleName).trim() !== ''
  ) {
    parts.push(String(employee.middleName).trim());
  }
  parts.push(employee.lastName);

  return parts
    .filter((part) => part && String(part).trim() !== '')
    .join(' ')
    .trim();
}

export function formatEmployeeFullName(employee: EmployeeNameInput): string {
  return formatEmployeeNameParts(employee, {includeMiddle: true});
}
